var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatboard2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 874.08,
    height: 602.783,
    viewBox: "0 0 874.08 602.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_325",
    x: 0,
    y: 0,
    width: 874.08,
    height: 602.783,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#002567",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 769,
    height: 498,
    rx: 10,
    transform: "translate(873 4389)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285",
    transform: "translate(-820.42 -4336.92)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 820.42, 4336.92)",
    filter: "url(#Rectangle_325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325-2",
    "data-name": "Rectangle 325",
    width: 769.08,
    height: 497.783,
    rx: 10,
    transform: "translate(52.5 52.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_45",
    "data-name": "Mask Group 45",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(872.92 4389.42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 769.08,
    height: 497.783,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 182.884,
    height: 497.783,
    fill: "#fbfbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 42.39,
    height: 497.783,
    fill: "#002e81"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 24.223,
    height: 24.223,
    rx: 5,
    transform: "translate(9.689 73.88)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 24.223,
    height: 24.223,
    rx: 5,
    transform: "translate(9.689 12.112)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 24.223,
    height: 24.223,
    rx: 5,
    transform: "translate(9.689 110.215)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 24.223,
    height: 24.223,
    rx: 5,
    transform: "translate(9.689 146.549)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 24.223,
    height: 24.223,
    rx: 5,
    transform: "translate(9.689 182.884)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24.223,
    height: 24.223,
    rx: 5,
    transform: "translate(9.689 219.218)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 24.223,
    height: 24.223,
    rx: 5,
    transform: "translate(9.689 457.815)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 59.346,
    height: 16.956,
    rx: 2,
    transform: "translate(55.713 12.112)",
    fill: "#002e81",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 91.588,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 77.514)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 319.285,
    height: 53.291,
    rx: 2,
    transform: "translate(227.696 27.856)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 319.285,
    height: 53.291,
    rx: 2,
    transform: "translate(227.696 209.529)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 319.285,
    height: 53.291,
    rx: 2,
    transform: "translate(393.624 98.103)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 319.285,
    height: 53.291,
    rx: 2,
    transform: "translate(227.696 329.433)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 319.285,
    height: 33.912,
    rx: 2,
    transform: "translate(393.624 159.872)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 319.285,
    height: 33.912,
    rx: 2,
    transform: "translate(227.696 391.202)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 319.285,
    height: 33.912,
    rx: 2,
    transform: "translate(393.624 279.776)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 91.588,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 111.426)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 91.588,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 145.338)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 91.588,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 179.25)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 91.588,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 213.162)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 24.223,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 85.992)",
    fill: "#002e81",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 24.223,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 119.904)",
    fill: "#002e81",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 24.223,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 153.816)",
    fill: "#002e81",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 24.223,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 187.728)",
    fill: "#002e81",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 24.223,
    height: 6.056,
    rx: 2,
    transform: "translate(79.936 221.64)",
    fill: "#002e81",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 16.956,
    height: 16.956,
    rx: 7,
    transform: "translate(55.713 77.514)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 23.012,
    height: 23.012,
    rx: 10,
    transform: "translate(197.417 27.856)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 23.012,
    height: 23.012,
    rx: 10,
    transform: "translate(197.417 209.529)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 23.012,
    height: 23.012,
    rx: 10,
    transform: "translate(197.417 329.433)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 23.012,
    height: 23.012,
    rx: 10,
    transform: "translate(720.175 98.103)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 23.012,
    height: 23.012,
    rx: 10,
    transform: "translate(720.175 279.776)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 16.956,
    height: 16.956,
    rx: 7,
    transform: "translate(55.713 111.426)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 16.956,
    height: 16.956,
    rx: 7,
    transform: "translate(55.713 145.338)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 16.956,
    height: 16.956,
    rx: 7,
    transform: "translate(55.713 179.25)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 16.956,
    height: 16.956,
    rx: 7,
    transform: "translate(55.713 213.162)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 27.856,
    height: 12.112,
    rx: 2,
    transform: "translate(55.713 38.757)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 44.813,
    height: 12.112,
    rx: 2,
    transform: "translate(96.892 38.757)",
    fill: "#002e81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 294.354,
    height: 12.112,
    rx: 6.056,
    transform: "translate(239.808 38.757)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 294.354,
    height: 12.112,
    rx: 6.056,
    transform: "translate(239.808 220.429)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 294.555,
    height: 12.112,
    rx: 6.056,
    transform: "translate(406.242 109.004)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 294.555,
    height: 12.112,
    rx: 6.056,
    transform: "translate(240.314 340.333)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 294.555,
    height: 12.112,
    rx: 6.056,
    transform: "translate(406.242 170.772)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 294.555,
    height: 12.112,
    rx: 6.056,
    transform: "translate(240.314 402.102)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 294.555,
    height: 12.112,
    rx: 6.056,
    transform: "translate(406.242 290.676)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 294.354,
    height: 12.112,
    rx: 6.056,
    transform: "translate(239.808 59.346)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 294.354,
    height: 12.112,
    rx: 6.056,
    transform: "translate(239.808 241.019)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 294.555,
    height: 12.112,
    rx: 6.056,
    transform: "translate(406.242 129.593)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 294.555,
    height: 12.112,
    rx: 6.056,
    transform: "translate(240.314 360.923)",
    fill: "#fff",
    opacity: 0.75
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatboard2);
export default __webpack_public_path__ + "static/media/chatboard-2.88be8f3f2d2bfefa2aa3722cfd63aa53.svg";
export { ForwardRef as ReactComponent };